import React from 'react';
import MediaQuery from 'react-responsive';

const MOBILE_WIDTH = 576;
const LAYOUT_WIDTH = 796;

export const SmallerThanLayout = (props) => (
    <MediaQuery {...props} maxWidth={LAYOUT_WIDTH}/>
);

export const LargerThanLayout = (props) => (
    <MediaQuery {...props} minWidth={LAYOUT_WIDTH + 1}/>
);

export const LargerThanMobile = (props) => (
    <MediaQuery {...props} minWidth={MOBILE_WIDTH + 1}/>
);

export const Mobile = (props) => (
    <MediaQuery {...props} maxWidth={MOBILE_WIDTH}/>
);